var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomestico(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.695,0.089C121.586-3.603,3.78,108.194,0.089,249.303S108.196,508.219,249.303,511.91 C390.411,515.6,508.219,403.803,511.91,262.695C515.6,121.587,403.804,3.781,262.695,0.089z M469.259,261.58 C466.181,379.172,368.01,472.335,250.42,469.259C132.827,466.181,39.663,368.011,42.74,250.42 C45.817,132.828,143.987,39.665,261.579,42.741S472.335,143.989,469.259,261.58z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.443,291.555l-71.111-12.033v37.633l14.222,17.067v28.444l-35.555-14.222l-35.555,14.222v-28.444l14.222-17.067v-37.633l-71.111,12.033V263.11l71.111-48.136v-30.086c0-11.782,9.552-21.333,21.333-21.333s21.333,9.552,21.333,21.333v30.086l71.111,48.136V291.555z",
    fill: "white",
    transform: "translate(256, 256) scale(1.4) translate(-256, -256)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomestico);
export default __webpack_public_path__ + "static/media/domestico.f2e755b21f116002966e7ac9e1328ffa.svg";
export { ForwardRef as ReactComponent };